<template>
  <div>
    <v-dialog persistent v-model="dialog" width="50%">
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on">
          <slot/>
        </span>
      </template>
      <v-form
        ref="form"
        v-model="form.valid"
        lazy-validation
        @submit.prevent="onSubmit"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            <span>Add container for storage : {{ storage }}</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="form.fields.storage"
              :rules="form.rules.storage"
              disabled
              label="Storage"
              required
            ></v-text-field>
            <v-text-field
              v-model="form.fields.container"
              label="Container Name"
              :rules="form.rules.container"
              :disabled="edit"
              required
            ></v-text-field>
            <v-text-field
              v-model="form.fields.azureName"
              label="Azure Name"
              :rules="form.rules.azureName"
              required
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn type="submit" color="primary" :disabled="!form.valid">
              Submit
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="dialog = false">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import {minLengthRule, requiredRule} from '@/utils/rules.js';
import {createNamespacedHelpers} from 'vuex';

const {mapActions} = createNamespacedHelpers('storage')
export default {
  name: 'AddContainerForm',
  data() {
    return {
      form: {
        valid: false,
        fields: {
          azureName: this.azureName,
          container: this.container,
          storage: this.storage
        },
        rules: {
          storage: [requiredRule()],
          azureName: [requiredRule(), minLengthRule(3)],
          container: [requiredRule(), minLengthRule(3)]
        }
      },
      dialog: false
    };
  },
  methods: {
    ...mapActions(['addContainer']),
    async onSubmit() {
      await this.addContainer({...this.form.fields})
      this.dialog = false;
    }
  },
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    azureName: {
      type: String,
      require: false,
      default: ''
    },
    container: {
      type: String,
      require: false,
      default: ''
    },
    storage: {
      type: String,
      required: true
    }
  }
};
</script>
